import React from 'react';
import { Box, Button } from '@mui/material';
import SummarizeIcon from '@mui/icons-material/Summarize';

import { IResultDetails } from 'interfaces/HistoricalResults/IResultDetails';

import './ResultDetails.scss';
import moment from 'moment';

interface IResultDetailsProps {
  resultDetails: IResultDetails;
  setShowDocuments: any;
  hasDocuments: boolean;
}

const ResultDetails = ({ resultDetails, setShowDocuments, hasDocuments }: IResultDetailsProps) => {
  return (
    <Box className="resultDetails">
      <Box>
        <Box>
          <p>Lab Number</p>
          <p>{resultDetails?.RegTid}</p>
        </Box>

        <Box>
          <p>Job Description</p>
          <p>{resultDetails?.Name}</p>
        </Box>

        <Box>
          <p>Requested By</p>
          <p>{resultDetails?.RequestedBy}</p>
        </Box>
      </Box>

      <Box>
        <Box>
          <p>Date Registered</p>
          <p>{resultDetails?.DateRequested ? moment(resultDetails?.DateRequested).format("DD/MM/yyyy") : null}</p>
        </Box>

        <Box>
          <p>Date Due</p>
          <p>{resultDetails?.DateDue ? moment(resultDetails?.DateDue).format("DD/MM/yyyy") : null}</p>
        </Box>

        <Box>
          <p>Job Status</p>
          <p>
            {resultDetails?.Status} {resultDetails?.StatCd === 3 && resultDetails?.DateComplete ? moment(resultDetails?.DateComplete).format("DD/MM/yyyy") : null}
          </p>
        </Box>
      </Box>

      <Box className="resultActions">
        {hasDocuments ? (
          <Button onClick={() => setShowDocuments(true)}>
            <SummarizeIcon />
          </Button>
        ) : null}
      </Box>
    </Box>
  );
};

export default ResultDetails;
